"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ArrowRight;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ArrowRight(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Arrows_",
    "data-name": "Arrows+"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M30.183,92.5a2.5,2.5,0,0,1-1.767-4.268L66.647,50,28.417,11.768a2.5,2.5,0,1,1,3.535-3.536L71.328,47.61a3.385,3.385,0,0,1,0,4.781L31.951,91.768A2.493,2.493,0,0,1,30.183,92.5Zm37.61-41.354h0Z"
  }))));
}